import { EnumOption } from './enum-option';
import { createEnumOptions } from '../../shared/utils';

export enum MatterStatus {
  Open = 0,
  Approved = 1,
  Closed = 2,
}

export const MatterStatusList: EnumOption[] = createEnumOptions(MatterStatus);
